import * as React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import { filterFields } from 'modules/core/components/EmployeeMultiFilters/commonFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import { useEmployeeGroups } from 'modules/core/components/MultiFilters/hooks/useEmployeeGroups'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/layout/components/Page/Loading'

type EmployeeMultiFiltersProps = React.ComponentProps<typeof EmployeeMultiFilters>
interface Props {
  filtersForm: FiltersForm
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: EmployeeMultiFiltersProps['onApplyFilters']
  onCancel: () => void
}

const SearchBar = ({
  onSearch,
  search,
  filtersForm,
  filters,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
}: Props) => {
  const sortAttribute = filtersForm.get('sortAttribute').value
  const sortDirection = filtersForm.get('sortDirection').value
  const { employeeGroups } = useEmployeeGroups()
  const [fields, setFields] = React.useState<readonly MultiFilterOption[]>([])

  const { loading } = useAsyncData(async () => {
    const fields = await filterFields(employeeGroups)

    setFields(fields)
  }, [])

  if (loading) {
    return <Loading />
  }

  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Box flexNoShrink>
        <EmployeeMultiFilters
          label={i18n.t('filters.multi_filters.title')}
          fields={fields}
          filters={filters}
          logicOperator={logicOperator}
          dense
          onAddFilter={onAddFilter}
          onRemoveFilter={onRemoveFilter}
          onApplyFilters={onApplyFilters}
          onCancel={onCancel}
          showDefaultFilters
          filterKey={filtersForm.get('filterBy').value}
          filterDependencies={[sortAttribute, sortDirection]}
        />
      </Box>
      <Box width="full">
        <SearchField
          variant="regular"
          onSearch={onSearch}
          search={search}
          placeholder={i18n.t('common.search')}
        />
      </Box>
    </Box>
  )
}

export default observer(SearchBar)
